<template>
  <div class="certificate-wrapper" @click.stop="close">
    <div ref="certificate" class="certificate">
      <img class="close" @click="close" src="https://img1.wxzxzj.com/vued5f10bcdd9d97e831fd3e0b0b8432dba8.png" alt="">
      <div class="certificate-title">
        <div>{{info.schoolName}}</div>
        <div>测试报告</div>
      </div>
      <div class="main">
        <div class="name-wrapper">
          <div class="name">{{info.name}}</div>
          <div>同学：</div>
        </div>
        <div class="title">
          <div>恭喜你完成了<span>【{{info.courseName}}—{{info.unitName}}】</span>的学习。</div>
          <div>请保持学霸速度，继续挑战！</div>
        </div>
        <div class="describe">
          <div>你已牢牢掌握本单元学习内容，</div>
          <div>获得了<span class="score">{{info.score}}</span>分的好成绩！</div>
          <!-- <div>
            <div>
              <span>学习前：</span>
              <span class="word">{{info.beforeWordCount}}</span>
              <span>个单词</span>
            </div>
            <div class="vs">VS</div>
            <div>
              <span>学习后牢牢掌握</span>
              <span class="word">{{info.afterWordCount}}</span>
              <span>个单词，</span>
              <span class="score">{{info.afterScore}}</span>
              <span>分</span>
            </div>
          </div> -->
        </div>
        <!-- <div class="addition">
          <div class="no-pass" v-if="results.length">
            <div class="no-pass-title">以下单词还需要重点练习</div>
            <div class="table-wrap">
              <div class="result-table">
                <div class="table-head">
                  <div>#</div>
                  <div>单词</div>
                  <div>解释</div>
                  <div>类型</div>
                  <div>我的</div>
                </div>
                <div class="table-body">
                  <div class="item" v-for="(quiz, index) in results" :key="index">
                    <div>{{index + 1}}</div>
                    <div class="text">
                      <div class="text-wrap">
                        <van-speaker class="normal primary" :src="quiz.audio" />
                        <span>&nbsp;{{quiz.text}}</span>
                      </div>
                    </div>
                    <el-tooltip
                      effect="light"
                      transition=""
                      :disabled="quiz.explain.length <= 18"
                      :content="quiz.explain"
                      :open-delay="400"
                      placement="right-start">
                      <div>
                        <span>{{quiz.explain}}</span>
                      </div>
                    </el-tooltip>
                    <div>
                      <template v-if="quiz.code === 'CHXZ'">词汇选择</template>
                      <template v-else>单词拼写</template>
                    </div>
                    <div>
                      <template v-if="quiz.code === 'CHXZ'">
                        <i class="el-icon-close error"></i>
                      </template>
                      <template v-else>
                        <template v-if="quiz.userAnswer">
                          <span class="error">{{quiz.userAnswer}}</span>
                        </template>
                        <span class="error no-data" v-else>未作答</span>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isReplay" class="no-pass-bottom">
              <el-button type="danger" @click="replay">错题再练</el-button>
            </div>
          </div>
          <div class="pass" v-else>全部熟词通过，你太牛了！</div>
        </div> -->
      </div>
      <div class="qrcode-wrapper">
        <van-q-r-code :value="url" :options="{ width: 140, type: 'image/png' }" tag="img" />
        <div class="time-wrapper">
          <div class="time">{{formatDate}}</div>
          <div>扫描二维码即可分享图片</div>
        </div>
      </div>
      <img class="seal" src="https://img1.wxzxzj.com/vued85c591126f86307e8a22ee67d98e9549.png" alt="">
    </div>
  </div>
</template>

<script>
// import { Tooltip, Button } from 'element-ui';
import utils from '@/services/utils';
import VanQRCode from '@chenfengyuan/vue-qrcode';

export default {
  components: {
    VanQRCode,
  },
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    isReplay: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formatDate() {
      return utils.Date.format(new Date(this.info.time), 'yyyy年MM月dd日');
    },
    url() {
      /* eslint-disable */
      const account = utils.storage('account');
      const { id } = account;
      const {
        certificateId,
      } = this.info;
      return `${window.location.protocol}//${window.location.host}/#/certificate?exam_id=${encodeURIComponent(certificateId)}&user_id=${encodeURIComponent(id)}`;
    },
  },
  mounted() {
  },
  data() {
    return {
      quizName: {
        CHXZ: {
          1: '词汇选择（选解释）',
          2: '词汇选择（选单词）',
          3: '听音选词',
          4: '听音选义',
        },
        DX: {
          0: '单项选择',
        },
        HYDC: {
          0: '还原单词',
        },
        DCTX: {
          0: '单词听写',
        },
        SK: {
          1: '闪卡练习（学习模式）',
          2: '闪卡练习（抄写模式）',
          3: '闪卡练习（录音模式）',
        },
        HYDX: {
          0: '还原单词',
        },
        DCPX: {
          1: '单词拼写（随机模式）',
          2: '单词拼写（默写模式）',
          3: '单词拼写（自定义模式）',
        },
        TYLJ: {
          0: '听音连句',
        },
        BQWZ: {
          0: '补全文章',
        },
        JXZH: {
          0: '句型转换',
        },
        QHLJ: {
          1: '强化炼句（简单模式）',
          2: '强化炼句（复杂模式）',
          3: '强化炼句（默写模式）',
          4: '强化炼句（自定义模式）',
        },
        YDLJ: {
          0: '阅读理解',
        },
        XCTK: {
          0: '选词填空',
        },
        THXZ: {
          0: '听后选择',
        },
        WXTK: {
          0: '完形填空',
        },
      },
      image: '',
    };
  },
  methods: {
    close(event) {
      const { className } = event.target;
      if (className === 'certificate-wrapper' || className === 'close') {
        this.$emit('close');
      }
    },
    replay() {
      this.$emit('replay');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  .certificate-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    filter: alpha(opacity=60);
    z-index: 99999;
    .certificate {
      box-sizing: border-box;
      margin: 0 auto;
      padding: 60px 150px 50px;
      position: relative;
      // width: 95%;
      width: 1300px;
      height: 650px;
      // min-height: 700px;
      font-size: 26px;
      background-image: url('https://img1.wxzxzj.com/vued81741947061bfe751f293aebc166b8e2.jpeg');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      .certificate-title {
        margin: 0 auto;
        width: 400px;
        border-radius: 5px;
        text-align: center;
        font-size: 35px;
        color: #fff;
        background-color: #4984f7;
        overflow: hidden;
        div {
          margin: 5px 0;
        }
      }
      .close {
        position: absolute;
        top: 0;
        right: 0;
        color: #fff;
        cursor: pointer;
      }
      .name-wrapper {
        display: flex;
        font-weight: 700;
        .name {
          border-bottom: 1px solid $primary;
          color: $primary;
        }
      }
      .main {
        position: relative;
        height: 100%;
        .title {
          margin-top: 10px;
          width: 100%;
          text-align: center;
          line-height: 3;
          // color: #104291;
          span {
            color: $primary;
          }
        }
        .describe {
          font-size: 35px;
          line-height: 3;
          font-weight: 700;
          text-align: center;
          .score {
            color: $danger;
            font-weight: 700;
            // border-bottom: 1px solid #104291;
          }
          .word {
            color: $danger;
            font-weight: 700;
            // border-bottom: 1px solid #104291;
          }
          .vs {
            font-size: 45px;
            color: red;
          }
        }
        .addition {
          margin-top: 20px;
          height: calc(100% - 251px);
          .no-pass {
            height: 100%;
            .no-pass-title {
              color: #104291;
              text-align: center;
            }
            .table-wrap {
              margin-top: 20px;
              height: calc(100% - 120px);
              .result-table {
                margin: 0 auto;
                width: 60%;
                height: 100%;
                text-align: center;
                font-size: 18px;
                box-shadow: 0 2px 6px 0 rgba(0,0,0,0.30);
                .table-head {
                  width: 100%;
                  div {
                    display: inline-block;
                    height: 40px;
                    line-height: 40px;
                    border-bottom: 1px solid $gray-bg-color;
                  }
                  div:first-child {
                    width: 10%;
                  }
                  div:nth-child(2) {
                    width: 20%;
                  }
                  div:nth-child(3) {
                    width: 35%;
                  }
                  div:nth-child(4) {
                    width: 15%;
                  }
                  div:last-child {
                    width: 20%;
                  }
                }
                .table-body {
                  width: 100%;
                  max-height: calc(100% - 41px);
                  overflow-y: auto;
                  .item {
                    width: 100%;
                    border-bottom: 1px solid $gray-bg-color;
                    .no-data {
                      font-size: 16px!important;
                    }
                    div {
                      display: inline-block;
                      width: 22.5%;
                      height: 40px;
                      line-height: 40px;
                      overflow: hidden;
                      text-overflow:ellipsis;
                      white-space: nowrap;
                    }
                    div:first-child {
                      width: 10%;
                    }
                    div:nth-child(2) {
                      width: 20%;
                    }
                    div:nth-child(3) {
                      width: 35%;
                    }
                    div:nth-child(4) {
                      width: 15%;
                    }
                    div:last-child {
                      width: 20%;
                    }
                    .text {
                      position: relative;
                      .text-wrap {
                        width: 80%;
                        text-align: left;
                      }
                    }
                    .error {
                      font-size: 18px;
                      font-weight: 700;
                      color: $danger;
                    }
                    .success {
                      font-size: 18px;
                      font-weight: 700;
                      color: $success;
                    }
                  }
                  .item:last-child {
                    border-bottom: 0;
                  }
                }
              }
            }
            .no-pass-bottom {
              margin-top: 10px;
              width: 100%;
              text-align: center;
            }
          }
          .pass {
            color: #104291;
            text-align: center;
          }
        }
      }
      .qrcode-wrapper {
        display: flex;
        position: absolute;
        bottom: 10%;
        left: 7%;
        text-align: center;
        .time-wrapper {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          font-size: 12px;
          text-align: left;
          .time {
            margin-bottom: 4px;
            font-size: 20px;
          }
        }
        .qrcode {
          width: 80px;
          height: 80px;
        }
      }
      .seal {
        width: 180px;
        position: absolute;
        bottom: 50px;
        right: 55px;
      }
      .organization {
        padding: 0 10px;
        position: absolute;
        bottom: 10%;
        right: 7%;
        border-top: 5px dotted #2270ad;
        line-height: 1.5;
      }
    }
  }
</style>
